import React, { useContext, useState } from 'react';

import classNames from 'classnames';
import { ChevronDown, ChevronUp } from 'lucide-react';

import { LocationContext, RouterContext } from 'common/containers/RouterContainer';
import Helmet from 'common/helmets/Helmet';
import styles from 'css-module/components/www/_Faqs.module.scss';

export type FAQ = {
  question: string;
  html: React.ReactNode | string;
  id?: string;
  answer: string;
};

/**
 * @deprecated Please use LandingV3/LandingFAQ instead
 */
interface Props {
  faqs: FAQ[];
}
const FAQs = ({ faqs }: Props) => {
  const location = useContext(LocationContext);
  const router = useContext(RouterContext);

  const [openedQuestions, setOpenedQuestions] = useState<boolean[]>(
    new Array(faqs.length).fill(false),
  );

  // if location.hash is set, force the question to be open
  let forceOpenQuestionIndex = -1;
  if (location.hash) {
    const questionID = location.hash.slice(1);
    const questionIndex = faqs.findIndex((question) => question.id === questionID);
    if (questionIndex !== -1) {
      forceOpenQuestionIndex = questionIndex;
    }
  }

  const handleClick = (index: number) => {
    // if a question is closed, remove it from location.hash
    if (location.hash) {
      const questionID = location.hash.slice(1);
      const questionIndex = faqs.findIndex((question) => question.id === questionID);
      if (questionIndex === index) {
        router.replace(location.pathname);
      }
    }

    // wait for router to update location.hash
    setTimeout(() => {
      const newOpenedQuestions = [...openedQuestions];
      const newState = index === forceOpenQuestionIndex ? false : !openedQuestions[index];
      newOpenedQuestions.splice(index, 1, newState);
      setOpenedQuestions(newOpenedQuestions);
    }, 0);
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((questionObject) => ({
              '@type': 'Question',
              name: questionObject.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: questionObject.answer,
              },
            })),
          })}
        </script>
      </Helmet>
      <section className={styles.FAQs}>
        <h2 className={styles.faqHeader}>Faq</h2>
        <ul className={styles.questionsWrapper}>
          {faqs.map((questionObject, index) => {
            const open = forceOpenQuestionIndex === index ? true : openedQuestions[index];
            return (
              <li
                className={classNames(styles.questionWrapper, { [styles.open]: open })}
                id={questionObject.id}
                key={index}>
                <button className={styles.question} onClick={() => handleClick(index)}>
                  {questionObject.question}
                  {openedQuestions[index] ? (
                    <ChevronUp className={styles.accordionIcon} />
                  ) : (
                    <ChevronDown className={styles.accordionIcon} />
                  )}
                </button>
                <div className={styles.answer}>{questionObject.html}</div>
              </li>
            );
          })}
        </ul>
      </section>
    </>
  );
};

export default FAQs;
